'use strict';

var error = require('@flex-packages/error');

function handleCustomError(error$1) {
  const [errorType, httpError] = error.decideError(error$1);
  let isHandled = false;
  switch (errorType) {
    case error.CustomErrorType.RouteChangeCanceled: {
      isHandled = true;
      break;
    }
  }
  return { isHandled, errorType, httpError };
}

exports.handleCustomError = handleCustomError;
//# sourceMappingURL=utils.cjs.map
